import Topbar from "../layout/Topbar";
// import Navbar from "./Navbar";

const Header = () => {
  return (
    <header>
      {/* Topbar */}
      <Topbar />
    </header>
  );
};

export default Header;
